<script>
	import { onMount } from 'svelte';
	
	export let html;
	let classes = '';
	
	onMount(() => {
		const tempDiv = document.createElement('div');
		tempDiv.innerHTML = html;
		classes = tempDiv.querySelector('div')?.className;
	});
</script>

<div class="get_in_touch {classes}">
	<slot/>
</div>

<style global lang="scss">
	@import "../../style/variables";
	@import "../../style/mixins";
	
	.get_in_touch {
		width: 100%;
		margin-top: $spacing-mobile;
		margin-bottom: $spacing-mobile;
		padding: var(--spacing-mobile) calc(var(--spacing-mobile) * .8) calc(var(--spacing-mobile) * .8) calc(var(--spacing-mobile) * .8);
		background-color: #CCCCCC;
		color: black;

		.useCustomCss & {
			background: #7B7B7B;
			color: #FFF;
		}
		
		@include for-tablet-portrait-up {
			padding: calc(var(--spacing-mobile) * 2.5);
		}
		
		@include for-desktop-up {
			padding: calc(var(--spacing-mobile) * 3);
		}
		
		address {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			gap: px-to-em(20);
			
			@include for-tablet-portrait-up {
				flex-direction: row;
			}
			
			h3 {
				margin-bottom: 0;
			}
			
			> div {
				flex: 100% 0 0;
				display: grid;
				width: 100%;
				
				&:first-of-type {
					width: 100%;
					//align-items: center;
					grid-template-columns: 30% 70%;
					grid-template-rows: auto;
					
					@include for-tablet-portrait-up {
						flex: 40% 0 0;
						display: grid;
						grid-template-columns: 35% 65%;
					}
					
					@include for-tablet-landscape-up {
						flex: 45% 0 0;
						grid-template-rows: 32% 23%;
					}
					
					@include for-desktop-up {
						grid-template-rows: 30% 25% 25%;
					}
				}
				
				&:nth-of-type(2) {
					@include for-tablet-portrait-up {
						flex-flow: column;
						display: flex;
						flex: auto;
					}
				}
				
				img {
					grid-row: 1 / span 3;
					width: 100%;
					border-radius: 50%;
				}
			}
		}
		
		h3 {
			@include font-px-to-rem(25, 40, 600);
			margin-bottom: var(--spacing-mobile);
			
			@include for-desktop-up {
				margin-bottom: calc(var(--spacing-mobile) * 2);
			}
		}
		
		.vcard {
			address {
				font-style: normal;
				
				& div:first-of-type {
					margin-bottom: var(--spacing-mobile);
					
					@include for-tablet-portrait-up {
						margin-bottom: 0;
					}
				}

				.buttons {
					display: grid;
					grid-template-columns: 1fr;
					gap: px-to-em(20);

					@include for-desktop-up {
						grid-template-columns: auto auto;

						h3 {
							grid-column-start: 1;
							grid-column-end: 3;
						}
					}
				}
			}
			
			img {
				align-self: center;
			}
			
			& span {
				margin-left: calc(var(--spacing-mobile) * 0.8);
				
				&.tel a {
					text-decoration: underline;
				}
			}
		}
		
		button {
			border: none;

			@include for-tablet-portrait-up {
				margin: 0;
				padding: 0;
				
				&:first-of-type {
					margin-right: $spacing-mobile*0.5;
				}
			}
			
			:global(a) {
				vertical-align: super;
				@include font-px-to-rem(18, 55, 300);
			}
			
			&.blue {
				width: 100%;
				background-color: $color-burgeins-6;
				color: white;
				border-radius: $border-burgeins;
				text-transform: uppercase;
				margin-bottom: .75em;
			}
			
			&.save > a::before {
				content: "";
				background-image: url("/img/icons/IconVCard.svg");
				background-size: 30px 30px;
				display: inline-block;
				position: relative;
				aspect-ratio: 1;
				@include wh-trbl(30px, 30px, .6em, 0, 0, -.6em);
			}
			
			&.contact :global(a::before) {
				content: "";
				background-image: url("/img/icons/IconSpeechBubbles.svg");
				background-size: 22px 22px;
				display: inline-block;
				position: relative;
				aspect-ratio: 1;
				@include wh-trbl(22px, 22px, .4em, 0, 0, -.6em);
			}
		}
	}
</style>
